import { Embed } from '@/types/embed'

export function embedScaling(embed: Embed) {
  if (embed.type === 'equipment') {
    return { width: 340, height: 284 }
  } else if (embed.type === 'ascendancy') {
    return { width: 340, height: 380 }
  } else if (embed.type === 'pantheon') {
    return { width: 340, height: 361 }
  } else if (embed.type === 'skills') {
    const maxSkills = Math.max(...embed.steps.map((step) => step?.skills.length || 0))
    return {
      width: 340,
      height: 47 * maxSkills + 32 + (embed.steps.length > 1 ? 25 + 22 : 0)
    }
  }
}
